
import { X } from "lucide-react";
import React from "react";

export default function PaymentConfirmationModal({
  isOpen,
  onConfirm,
  onCancel,
  message,
}) {
  if (!isOpen) return null;

  const backdropClick = () => onCancel();
  const stop = (e) => e.stopPropagation();

  // console.log(message, "payment amount ");

  return (
    // Enhanced backdrop with smoother animation
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-md animate-fade-in"
      onClick={backdropClick}
    >
      {/* Enhanced modal card with scale animation */}
      <div
        onClick={stop}
        className="relative w-[90%] max-w-md transform animate-scale-in rounded-2xl bg-gradient-to-br from-white to-gray-50 p-8 shadow-2xl border border-gray-100"
      >
        {/* Close button with better styling */}
        <button
          onClick={onCancel}
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-500 transition-all duration-200 hover:bg-gray-200 hover:text-gray-700 hover:scale-110"
        >
          <X className="h-4 w-4" />
        </button>

        {/* Payment icon */}
        <div className="mb-6 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 shadow-lg">
            <svg
              className="h-8 w-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
          </div>
        </div>

        {/* Enhanced title and message */}
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            Confirm Payment
          </h3>
          <p className="text-gray-600 mb-4">
            You are about to make a payment of
          </p>
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg">
            <span className="text-3xl font-bold text-green-700">₹{message}</span>
          </div>
          <p className="text-sm text-gray-500 mt-3">
            Please confirm to proceed with the transaction
          </p>
        </div>

        {/* Enhanced buttons */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 rounded-xl border-2 border-gray-200 bg-white px-6 py-3 font-semibold text-gray-700 transition-all duration-200 hover:border-red-300 hover:bg-red-50 hover:text-red-600 hover:shadow-md active:scale-95"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-3 font-semibold text-white shadow-lg transition-all duration-200 hover:from-indigo-700 hover:to-purple-700 hover:shadow-xl hover:scale-105 active:scale-95 focus:ring-4 focus:ring-indigo-200"
          >
            Confirm Payment
          </button>
        </div>

        {/* Security indicator */}
    
      </div>
    </div>
  );
}
